export const quoteServiceOptions: string[] = [
  'Collision / body repair',
  'Commercial truck painting',
  'Fleet bodywork',
  'Trailer / RV bodywork',
  'Restoration',
  'Something else',
];

export const MAX_QUOTE_FILES = 3;
